import { RegistrationContext } from '@/modules/RegisterLayout/contexts/RegistrationContextProvider';
import { CourseContext } from '@/modules/RegisterLayout/contexts/CoursesContextProvider';
import { PATTERN } from '@/modules/common/constants';
import { InputField, RadioButton } from '@pw-tech/omni-ui';
import React, { useContext } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// import GoogleEmailButton, { EmailConflict } from './GoogleEmailButton';

const InitialDetails = () => {
  const {
    registrationDetails
  } = useContext(RegistrationContext);
  const {
    selectedCourseData
  } = useContext(CourseContext);
  const {
    control,
    formState: {
      isValid,
      errors,
      isSubmitted,
      touchedFields
    }
  } = useFormContext();

  // const phoneNumber = useWatch({ control, name: 'phoneNumber' });

  const shouldShowError = (fieldName: keyof typeof touchedFields) => {
    return (isSubmitted || touchedFields[fieldName]) && errors[fieldName]?.message;
  };
  const isTwelfthPercentageRequired = selectedCourseData?.skipCeeExam || selectedCourseData?.batchCrmName?.includes('SOT');

  // Hide "Change account" after the first Save & Continue (when extended fields appear)
  // or on return visits where basic details are already persisted.
  // const hideChangeAccount = lockEmailChange || Boolean(registrationDetails?.tenthPercentage);

  // const handleEmailConflictChange = useCallback(
  //   (conflict: EmailConflict | null) => {
  //     if (conflict) {
  //       setError('email', { type: 'manual', message: conflict.message });
  //     } else {
  //       clearErrors('email');
  //     }
  //   },
  //   [setError, clearErrors]
  // );

  return <>
      {/* Name & Email */}
      <div className="flex flex-col md:!flex-row gap-4">
        <div className="w-full ">
          <Controller name="fullName" control={control} rules={{
          required: {
            value: true,
            message: 'Please enter the name'
          },
          minLength: {
            value: 2,
            message: 'Minimum 2 characters required'
          },
          pattern: {
            value: new RegExp(PATTERN.name),
            message: 'Please enter a valid name'
          }
        }} render={({
          field
        }) => <InputField {...field} label="Student's Full Name (as per 10th/12th Marksheet). *" placeholder="Enter Name" error={!!errors.fullName?.message} message={errors?.fullName?.message as string} disabled={registrationDetails?.isPaid} fullWidth />} data-sentry-element="Controller" data-sentry-source-file="InitialDetails.tsx" />
        </div>
        <div className="w-full">
          <Controller name="email" control={control} rules={{
          required: {
            value: true,
            message: 'Please enter the email address'
          },
          pattern: {
            value: new RegExp(PATTERN.email),
            message: 'Please enter a valid email address'
          }
        }} render={({
          field
        }) => <>
                <InputField {...field} label="Student's Email ID. *" placeholder="Enter Email" error={!!errors.email?.message} message={errors.email?.message as string} disabled={registrationDetails?.isPaid} fullWidth />
                {/* <GoogleEmailButton
                  label="Student's Email ID. *"
                  value={field.value}
                  onChange={field.onChange}
                  error={!!errors.email?.message}
                  message={errors.email?.message as string}
                  disabled={registrationDetails?.isPaid}
                  allowChangeAccount={!hideChangeAccount}
                  onConflictChange={handleEmailConflictChange}
                  phoneNumber={phoneNumber}
                 /> */}
              </>} data-sentry-element="Controller" data-sentry-source-file="InitialDetails.tsx" />
        </div>
      </div>

      {/* Class 10th & 12th Percentage */}
      <div className="flex flex-col md:!flex-row gap-4">
        <div className="w-full">
          <Controller name="tenthPercentage" control={control} rules={{
          required: {
            value: true,
            message: 'Class 10th Marks Required *'
          },
          pattern: {
            value: new RegExp(PATTERN.percentage),
            message: 'Please enter a valid percentage (0-100, up to 2 decimals)'
          }
        }} render={({
          field
        }) => <InputField {...field} step="0.01" min="0" max="100" label="Class 10th Marks In Percentage *" placeholder="Class 10th Marks In Percentage" error={shouldShowError('tenthPercentage')} message={shouldShowError('tenthPercentage') ? errors.tenthPercentage?.message as string : ''} disabled={registrationDetails?.isPaid} fullWidth />} data-sentry-element="Controller" data-sentry-source-file="InitialDetails.tsx" />
        </div>
        <div className="w-full">
          <Controller name="twelthPercentage" control={control} rules={{
          ...(isTwelfthPercentageRequired ? {
            required: {
              value: true,
              message: 'Class 12th Marks Required'
            },
            pattern: {
              value: new RegExp(PATTERN.percentage),
              message: 'Please enter a valid percentage (0-100, up to 2 decimals)'
            }
          } : {
            validate: (value: string) => !value || new RegExp(PATTERN.percentage).test(value) || 'Please enter a valid percentage (0-100, up to 2 decimals)'
          })
        }} render={({
          field
        }) => <InputField {...field} step="0.01" min="0" max="100" label={isTwelfthPercentageRequired ? 'Class 12th Marks In Percentage *' : 'Class 12th Marks In Percentage'} placeholder="Class 12th Marks In Percentage" error={shouldShowError('twelthPercentage')} message={shouldShowError('twelthPercentage') ? errors.twelthPercentage?.message as string : ''} disabled={registrationDetails?.isPaid} fullWidth />} data-sentry-element="Controller" data-sentry-source-file="InitialDetails.tsx" />
        </div>
      </div>
    </>;
};
export default InitialDetails;